// ============================================================
// 料金プランの判定（有料 / 無料）をここ1箇所に集約する
// ============================================================
import { db } from "../firebase";
import { collection, doc, getDoc, getDocs, query, where, limit } from "firebase/firestore";

/**
 * 有料プランと見なす billingStatus。Stripe の定期課金が有効なとき（または運営が手で「決済中」にしたとき）だけ "active" になる。
 * 書き換えるのはサーバー（functions/index.js の applySubscription）と運営画面だけ。
 */
export function isPaidBillingStatus(status) {
  return status === "active";
}

/**
 * 会社ドキュメントを取得する。
 * 通常は「会社コード = ドキュメントID」だが、運営画面から作成した会社は
 * ランダムIDに companyId フィールドを持つ形なので、その場合も拾えるようにする。
 */
export async function fetchCompany(companyId) {
  if (!companyId) return null;
  const snap = await getDoc(doc(db, "companies", companyId));
  if (snap.exists()) return snap.data();
  const qs = await getDocs(query(collection(db, "companies"), where("companyId", "==", companyId), limit(1)));
  return qs.empty ? null : qs.docs[0].data();
}

/**
 * 有料プランかどうか。取得に失敗したときは安全側（無料扱い）に倒す。
 * 運営が「テスター」に指定した会社は、支払いの有無にかかわらず有料扱いにする。
 */
export async function fetchIsPaidPlan(companyId) {
  try {
    const company = await fetchCompany(companyId);
    if (company?.isTester === true) return true;
    return isPaidBillingStatus(company?.billingStatus);
  } catch (e) {
    console.error("プラン状態の取得に失敗しました:", e);
    return false;
  }
}
